import { CommonEnums } from 'src/app/shared/common.enums';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
import { EditorInputObj } from 'src/app/shared/models/objs/editorinputobj';
import { AttributesGridUtil } from './attributes-grid.util';
import { Attribute } from 'src/app/shared/models/domain/attribute';
import { AttributesUtil } from './attributes.util';
import { AttributesComplexGridUtil } from './attributes-complex-grid.util';
import { DatabaseEnum } from '../../databases/databases.enum';
import { Repository } from 'src/app/modules/repository/repository';
import Tabulator from 'tabulator-tables';
import { Business_GlossaryGridComponent } from '../business_glossary/components/business_glossary-grid.component';

export class AttributeTabulator {
    private static instance: AttributeTabulator;
    tabulator: Tabulator;
    business_GlossaryGridComponent:Business_GlossaryGridComponent;

    static getInstance() {
        if (!AttributeTabulator.instance) {
            AttributeTabulator.instance = new AttributeTabulator();
        }

        return AttributeTabulator.instance;
    }

    /**
      * AttributeTabulator is a singleton class, so use AttributeTabulator.getInstance() method instead of creating new AttributeTabulator().
      */
    private constructor() {
    }

    getCheckBoxColumn(objectWrapper: ObjectWrapper, hideRowSelection: boolean = true): any {


        let column: any = {};
        column.formatter = "rowSelection"
        column.width = 40;
        column.align = "center";
        column.titleFormatter = "rowSelection"
        column.resizableColumn = false;
        column.headerSort = false;
        column.visible = hideRowSelection;
        return column;
    }

    getAttr_Id(): any {
        let column: any = {};

        column.title = "Id";
        column.field = "attr_Id";
        column.width = 100;
        column.headerSort = false;
        column.visible = false;

        return column;
    }

    getSrt_Order(): any {
        let column: any = {};

        column.title = "#";
        column.field = 'srt_Order';
        column.width = 50;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES)
                return attribute.srt_Order + 1;

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.srt_Order + 1;

            return element;
        }

        return column;
    }

    getAttrNm(objectWrapper: ObjectWrapper, component: any = null): any {
        let attributeTitle = objectWrapper.obj_Cd != 'DOBJ' && objectWrapper.obj_Cd != 'DOBJIT' && objectWrapper.obj_Cd != 'DESRUI' ? 'Alias' : 'Attribute';
        let column: any = {};

        column.title = attributeTitle;
        column.field = 'attrNm';
        column.width = 150;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.isEditable == CommonEnums.flag.YES &&
                attribute.clevel == 0) {
                let element: any = document.createElement("span");
                let attrNmText = document.createTextNode(attribute.attrNm);
                element.appendChild(attrNmText);
                return element;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.style.paddingLeft = (attribute.clevel * 2) + 'px';
            let attrNmText = document.createTextNode(attribute.attrNm);
            element.appendChild(attrNmText);
            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.NO) {
                // let element: any = document.createElement("span");
                // element.classList.add("font-italic");
                // element.style.paddingLeft = (attribute.clevel * 5) + 'px';
                // element.innerHTML = attribute.attrNm;
                return attribute.attrNm;
            }

            let oldAttrNm: string = attribute.attrNm;

            let editor: any;
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                attribute.attrNm = editor.value;
                if (attribute.attrNm == "") {
                    attribute.attrNm = oldAttrNm;
                    return;
                }

                if (editor.value != oldAttrNm) {
                    if (objectWrapper.subNames.indexOf(editor.value.toUpperCase()) != -1) {
                        attribute.attrNm = oldAttrNm;
                        editor.value = oldAttrNm;
                    } else {
                        let ValidatedAttNm = AttributesGridUtil.getInstance().attrNmBlur(attribute, oldAttrNm, objectWrapper, attribute.srt_Order)
                        editor.value = ValidatedAttNm;

                        success(editor.value);
                        cell.getRow().reformat();
                        //ObjectWrapperUtil.getInstance().updateSubName(editor.value, oldAttrNm, objectWrapper);
                        objectWrapper.setChange_Ind();
                        if (component)
                            component.updateRefreshCountForAttributes();
                    }

                }
                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getAttrDTyp_Id(objectWrapper: ObjectWrapper, attributes: Array<Attribute> = new Array<Attribute>(), component: any = null): any {
        let column: any = {};

        column.title = "Data Type";
        column.field = 'attrDTyp_Id';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.hideAttrDTyp_Id) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                let element: any = document.createElement("span");
                let attrDTypNmText = document.createTextNode(attribute.attrDTypNm);
                element.appendChild(attrDTypNmText);
                return element;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            let attrDTypNmText = document.createTextNode(attribute.attrDTypNm);
            element.appendChild(attrDTypNmText);
            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            function successFuncOnDisabled() {
                cancel();
            }

            let editor: any;
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor = document.createElement("select");
            editor.id = "mySelect";

            if (attribute.isEditable == CommonEnums.flag.NO) {
                editor.disabled = true;
                editor.addEventListener("click", successFuncOnDisabled);
            }

            let labelValueObjs: Array<any> = objectWrapper.databaseWrapper.labelValueObjs;
            if (objectWrapper.obj_Cd == 'DOBJIS' ||
                objectWrapper.obj_Cd == 'DOBJIT') {
                labelValueObjs = objectWrapper.designWrapper.nativeDbTyp_Id == DatabaseEnum.databaseId.GENERIC
                    ? objectWrapper.databaseWrapper.labelValueObjs
                    : objectWrapper.designWrapper.databaseWrapper.labelValueObjs;
            }

            for (let i: number = 0; i < labelValueObjs.length; i++) {
                let option = document.createElement("option");

                option.value = labelValueObjs[i].id;
                option.text = labelValueObjs[i].label;

                editor.appendChild(option);
            }

            editor.value = attribute.attrDTyp_Id;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            let oldAttrDTyp_Id: number = attribute.attrDTyp_Id;
            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (attribute.attrDTyp_Id == editor.value) {
                    success(editor.value);
                    return;
                }

                attribute.attrDTyp_Id = editor.value;
                for (let i: number = 0; i < labelValueObjs.length; i++) {
                    if (labelValueObjs[i].id == attribute.attrDTyp_Id) {
                        attribute.attrDTypNm = labelValueObjs[i].label;
                        break;
                    }
                }

                if (component) {
                    setTimeout(() => {
                        if (objectWrapper.databaseWrapper.isComplexType) {
                            AttributesComplexGridUtil.getInstance().attrDTyp_IdChanged(attribute, attributes, objectWrapper, oldAttrDTyp_Id);
                        } else {
                            AttributesGridUtil.getInstance().attrDTyp_IdChanged(attribute, attributes, objectWrapper, oldAttrDTyp_Id);
                        }
                        component.updateRefreshCountForAttributes();
                    });
                }
                AttributesUtil.getInstance().setAttributeReadOnlyProperties(attribute, objectWrapper);
                if (attribute.attrType_Cd == 'A' && attribute.lnk_Attr_Id != -1)
                    AttributesGridUtil.getInstance().setWarningForSrc_Attribute(attribute, objectWrapper);

                objectWrapper.doValidate();

                success(editor.value);
                cell.getRow().reformat();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getAttrPrec(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Prec";
        column.field = 'attrPrec';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (!attribute.showAttrPrec) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.attrPrec
            }
            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.attrPrec;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrPrec) {
                let element: any = document.createElement("span");
                return element;
            }

            if (attribute.isEditable == CommonEnums.flag.NO) {
                let element: any = document.createElement("span");
                element.classList.add("font-italic");
                element.style.paddingLeft = (attribute.clevel * 5) + 'px';
                element.innerHTML = attribute.attrPrec;
                return element;
            }

            let editor: any;
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor = document.createElement("input");
            editor.type = "number";
            editor.id = "myInput";
            editor.min = attribute.minAttrPrec;
            editor.max = attribute.maxAttrPrec;

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            let oldAttrPrec: number = attribute.attrPrec;

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.attrPrec = editor.value;

                if (editor.value != oldAttrPrec) {
                    if (editor.value < attribute.minAttrPrec ||
                        editor.value > attribute.maxAttrPrec) {
                        attribute.attrPrec = oldAttrPrec;
                        editor.value = oldAttrPrec;
                    } else {
                        objectWrapper.setChange_Ind();
                    }
                }
            }
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getAttrScale(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Scale";
        column.field = 'attrScale';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrScale) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.attrScale;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.attrScale;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.showAttrScale) {
                let element: any = document.createElement("span");
                return element;
            }

            if (attribute.isEditable == CommonEnums.flag.NO) {
                let element: any = document.createElement("span");
                element.classList.add("font-italic");
                element.innerHTML = attribute.attrScale;
                return element;
            }

            let editor: any = document.createElement("input");
            editor.type = 'number';
            editor.id = "myInput";

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            let oldAttrScale: number = attribute.attrScale;

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.attrScale = editor.value;

                if (editor.value != oldAttrScale) {
                    if (editor.value < attribute.minAttrScale ||
                        editor.value > attribute.maxAttrScale) {
                        attribute.attrPrec = oldAttrScale;
                        editor.value = oldAttrScale;
                    } else {
                        objectWrapper.setChange_Ind();
                    }
                }
            }
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getCdcFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "cdc";
        column.field = "cdcFlag";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "cdcFlag_" + attribute.attr_Id;
            editor.id = "cdcFlag_" + attribute.attr_Id;
            editor.checked = attribute.cdcFlag == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.cdcFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.doValidate();
            }
            return editor;
        }
        return column;
    }

    getNotNullFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Not Null";
        column.field = 'notNullFlag';
        column.width = 75;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (objectWrapper.databaseWrapper.hideNotNullFlag(attribute)) return;

            if (attribute.hideNotNullFlag) {
                return '';
            }

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "notNullFlag_" + attribute.attr_Id;
            editor.id = "notNullFlag_" + attribute.attr_Id;
            editor.checked = attribute.notNullFlag == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
            editor.onclick = function (event: any) {
                attribute.notNullFlag = event.target.checked ? 1 : 0;
                objectWrapper.setChange_Ind();
            }
            return editor;
        }
        return column;
    }

    getMaxFlag(objectWrapper: ObjectWrapper, isMax: boolean = false): any {
        let column: any = {};

        column.title = "Max";
        column.width = 50;
        column.field = 'maxFlag';
        column.headerSort = false;
        column.visible = isMax;

        column.formatter = function (cell) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "maxFlag_" + attribute.attr_Id;
            editor.id = "maxFlag_" + attribute.attr_Id;
            editor.checked = attribute.maxFlag == CommonEnums.flag.YES;


            if (attribute.attrDTypNm == "varchar" ||
                attribute.attrDTypNm == "nvarchar" ||
                attribute.attrDTypNm == "varbinary") {
                attribute.isMaxEditFlag = CommonEnums.flag.NO;
            }
            else {
                attribute.isMaxEditFlag = CommonEnums.flag.YES;
                attribute.maxFlag = CommonEnums.flag.NO;
            }

            if (attribute.isMaxEditFlag == 'Y' ||
                objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute('class', 'isDisabled');
                return editor;
            }
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.maxFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;

                if (attribute.maxFlag == CommonEnums.flag.YES) {
                    attribute.showAttrPrec = false;
                    attribute.attrPrec = 0;
                }
                else {
                    attribute.showAttrPrec = true;
                    attribute.attrPrec = 50;
                }
                cell.getRow().reformat();
                objectWrapper.setChange_Ind();
            }
            return editor;
        }
        return column;
    }

    getEncryptedFlag(objectWrapper: ObjectWrapper, isEncryptedFlag: boolean): any { //
        let column: any = {};

        column.title = "Encrypted";
        column.field = 'encrypted';
        column.width = 60;
        column.visible = isEncryptedFlag;
        column.headerSort = false;

        column.formatter = function (cell) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "encryptedFlag_" + attribute.attr_Id;
            editor.id = "encryptedFlag_" + attribute.attr_Id;
            editor.checked = attribute.encrypted == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE ||
                objectWrapper.obj_Cd != CommonEnums.codes.DATAOBJECT) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.encrypted = event.target.checked ? CommonEnums.flag.NO : CommonEnums.flag.YES;
                objectWrapper.setChange_Ind();
            }
            return editor;
        }
        return column;
    }

    getIdentityFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Identity";
        column.field = "identityFlag";
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "identityFlag_" + attribute.attr_Id;
            editor.id = "identityFlag_" + attribute.attr_Id;
            editor.checked = attribute.identityFlag == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor.onclick = function (event: any) {
                attribute.identityFlag = event.target.checked ? 1 : 0;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getRepeatedFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Repeated";
        column.field = 'repeatedFlag';
        column.width = 120;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "repeatedFlag_" + attribute.attr_Id;
            editor.id = "repeatedFlag_" + attribute.attr_Id;
            editor.checked = attribute.repeatedFlag == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.repeatedFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getAttrKeyTyp_Id(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Key Type";
        column.field = 'attrKeyTyp_Id';
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (objectWrapper.databaseWrapper.hideAttrKeyTyp_Id(attribute)) return;

            if (attribute.hideAttrKeyTyp_Id) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.attrKeyTypLabel;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.attrKeyTypLabel;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.obj_Cd != CommonEnums.codes.DATAOBJECT) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let attrKeyTyp_Ids: Array<any> = AttributesUtil.getInstance().attrKeyTyp_Ids;

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < attrKeyTyp_Ids.length; i++) {
                let option = document.createElement("option");
                option.value = attrKeyTyp_Ids[i].value;
                option.text = attrKeyTyp_Ids[i].label;
                editor.appendChild(option);
            }

            editor.value = attribute.attrKeyTyp_Id;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                attribute.attrKeyTyp_Id = parseInt(editor.value);

                for (let i: number = 0; i < attrKeyTyp_Ids.length; i++) {
                    if (attrKeyTyp_Ids[i].value == attribute.attrKeyTyp_Id) {
                        attribute.attrKeyTypLabel = attrKeyTyp_Ids[i].label;
                        break;
                    }
                }
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }


    getDist_FieldOffset(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Dist Field Start";
        column.field = 'colformat';
        column.width = 120;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.dist_FieldOffset == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.dist_FieldOffset;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.dist_FieldOffset;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.dist_FieldOffset;

            function successFunc() {
                attribute.dist_FieldOffset = parseInt(editor.value);
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);

            onRendered(function () {
                editor.focus();
            });

            return editor;
        }

        return column;
    }

    getDist_FieldSize(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Dist Field Size";
        column.field = "dist_FieldSize";
        column.width = 120;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.dist_FieldSize == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.dist_FieldSize;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.dist_FieldSize;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.dist_FieldSize;

            function successFunc() {
                attribute.dist_FieldSize = parseInt(editor.value);
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);

            onRendered(function () {
                editor.focus();
            });

            return editor;
        }
        return column;
    }

    getDistKeyFlag(objectWrapper: ObjectWrapper, title: string = ''): any {
        let column: any = {};

        column.title = title != '' ? title : "Dist";
        column.field = 'distKeyFlag';
        column.width = 60;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<Attribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < values.length; i++) {
                if (i == 5) break;
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;
                editor.appendChild(option);
            }

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.distKeyFlag = parseInt(editor.value);

                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }


        return column;
    }

    getClusterFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Cluster";
        column.field = "clusterFlag";
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "clusterFlag_" + attribute.attr_Id;
            editor.id = "clusterFlag_" + attribute.attr_Id;
            editor.checked = attribute.clusterFlag == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor.onclick = function (event: any) {
                attribute.clusterFlag = event.target.checked ? 1 : 0;
                let rowComponents: Array<any> = cell.getTable().getRows();

                if (attribute.clusterFlag == 0) {
                    for (let i: number = 0; i < rowComponents.length; i++) {
                        let _attribute: Attribute = rowComponents[i]._row.data;
                        _attribute.orderBy = 0;
                        rowComponents[i].reformat();
                    }

                }
                for (let i: number = 0; i < rowComponents.length; i++) {
                    let attributeExist = rowComponents[i]._row.data;
                    if (attribute.attr_Id == attributeExist.attr_Id) continue;

                    if (attribute.clusterFlag == attributeExist.clusterFlag) {
                        attributeExist.clusterFlag = 0;
                        rowComponents[i].reformat();
                        break;
                    }
                }

                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }


    //DDS-9528 Add clustering option in BQ data object(enable multiple clusters selection for bigquery only)
    getBigqueryClusterFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Cluster";
        column.field = "clusterFlag";
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "clusterFlag_" + attribute.attr_Id;
            editor.id = "clusterFlag_" + attribute.attr_Id;
            editor.checked = attribute.clusterFlag == 1;
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor.onclick = function (event: any) {
                attribute.clusterFlag = event.target.checked ? 1 : 0;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getPartitionflag(objectWrapper: ObjectWrapper, isHiveNative: boolean = true): any {
        let column: any = {};
        column.title = "Partition";
        column.field = 'partitionflag';
        column.width = 80;
        column.headerSort = false;
        column.visible = isHiveNative;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.partitionflag == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.partitionflag
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.partitionflag;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<Attribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);

            for (let i: number = 0; i < values.length; i++) {
                if (i == 6) break;
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.partitionflag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.partitionflag = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getBigQueryPartitionflag(objectWrapper: ObjectWrapper, component: any, isBigQueryNative: boolean = true): any {
        let column: any = {};
        column.title = "Partition";
        column.field = 'partitionflag';
        column.width = 80;
        column.headerSort = false;
        column.visible = isBigQueryNative;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.partitionflag == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.partitionflag
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.partitionflag;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!ObjectWrapperUtil.getInstance().verifyBigQueryPartitionDataType(attribute.attrDTyp_Id)) return '';
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<Attribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);

            for (let i: number = 0; i < values.length; i++) {
                if (i == 2) break;
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.partitionflag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);

                attribute.partitionflag = parseInt(editor.value);
                objectWrapper.partitionflagChanged(attribute);
                component.updateRefreshCountForAttributes();
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }
    getOrgKeyFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Org";
        column.field = "orgKeyFlag";
        column.width = 70;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.orgKeyFlag == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.orgKeyFlag;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.orgKeyFlag;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<Attribute> = cell._cell.column.cells;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;
                editor.appendChild(option);
            }

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.orgKeyFlag = parseInt(editor.value);
                objectWrapper.setChange_Ind();

            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getOrderBy(objectWrapper: ObjectWrapper, component: any, hideOrderBy: boolean = true): any {
        let column: any = {};

        column.title = "Order";
        column.field = "orderBy";
        column.width = 70;
        column.headerSort = false;
        column.visible = hideOrderBy;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.orderBy == 0) {
                return '';
            }

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.orderBy;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.orderBy;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor = document.createElement("select");
            editor.id = "mySelect";

            // let values: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            let values: Array<any> = objectWrapper.getAttributesLengthList();
            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;
                editor.appendChild(option);
            }

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });
            // Define event handler for when an option is selected
            editor.addEventListener('change', function () {
                // Get the selected value
                let selectedValue = editor.value;

                // Update the attribute's orderBy property
                attribute.orderBy = parseInt(selectedValue);

                // Call the orderByChanged method of the objectWrapper if needed
                let found = objectWrapper.object.attributes.some(attr => attr.clusterFlag === 1);
                if (found) {
                    objectWrapper.orderByChanged(attribute);
                } else {
                    attribute.orderBy = 0;
                }

                // Trigger the success callback
                success(selectedValue);

                // Update any necessary component state
                component.updateRefreshCountForAttributes();

                // Set the change indicator for the objectWrapper
                objectWrapper.setChange_Ind();
            });


            // function successFunc() {
            //     attribute.orderBy = parseInt(editor.value);

            //     let found: boolean = false;
            //     for (let i: number = 0; i < objectWrapper.object.attributes.length; i++) {
            //         let _attribute: Attribute = objectWrapper.object.attributes[i];
            //         if (_attribute.clusterFlag == 1) {
            //             found = true;
            //             break;
            //         }
            //     }
            //     if (found) {
            //         objectWrapper.orderByChanged(attribute);
            //     }
            //     else {
            //         attribute.orderBy = 0;
            //         editor.value = '0';
            //     }
            //     success(editor.value);
            //     component.updateRefreshCountForAttributes();
            //     objectWrapper.setChange_Ind();
            // }
            // editor.addEventListener("change", successFunc);
            // editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getValid_Cd(objectWrapper: ObjectWrapper, component: any): any {
        let column: any = {};

        column.title = "Error Message";
        column.field = 'valid_Cd';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (cell.getValue() == "0") {
                return '';
            }
            let element: any = document.createElement('button');
            element.setAttribute('class', ' border-0 btn bg-none text-warning hand');
            document.body.appendChild(element);
            //let oldAttrExprVal: string = attribute.attrExprVal;
            // function onClick() {
            //     if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            //         return;
            //     }
            //     let editorInputObj: EditorInputObj = new EditorInputObj();
            //     editorInputObj.objectWrapper = objectWrapper;
            //     editorInputObj.subObject = attribute;
            //     editorInputObj.subObjectCopy = attribute.copy();
            //     editorInputObj.exprVal = attribute.attrExprVal;
            //     editorInputObj.valueField = 'attrExprVal';
            //     editorInputObj.valid_CdField = 'valid_Cd';
            //     editorInputObj.srt_OrderField = 'srt_Order';
            //     editorInputObj.name = attribute.attrNm;
            //     editorInputObj.datatypeName = attribute.attrDTypNm;
            //     editorInputObj.objTypCode = objectWrapper.obj_Cd;
            //     editorInputObj.typeName = 'Attribute';

            //      component.openEditorPopup(editorInputObj);
            //     component.validationService.onBlurValidation(editorInputObj)
            //         .subscribe(() => {
            //             component.refreshCountForAttributeGrid++;
            //         })
            // }

            function onMouseOver() {
                let data: Array<string> = attribute.error_Msg.split(':');
                if (data.length > 1) {
                    attribute.error_Msg = data[1];
                }

                element.setAttribute('title', attribute.error_Msg.toString());
            }

            element.addEventListener("mouseover", onMouseOver);
            let imgElement: any = document.createElement('img');
            imgElement.setAttribute('src', 'assets/icons/common/info4.svg')
            element.appendChild(imgElement);

            return element;
        }

        return column;
    }

    getAttrExprVal(objectWrapper: ObjectWrapper, component: any): any {
        let column: any = {};

        column.title = "Expression";
        column.field = 'attrExprVal';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.hiddenFlg == 'Y') {
                return "<span></span>";
            }

            let editorElement: any = document.createElement('div');
            editorElement.setAttribute('class', 'exp-field');

            let inputElement: any = document.createElement('input');
            inputElement.setAttribute('type', 'text');
            inputElement.setAttribute('class', 'form-control form-control-sm exp-button');
            inputElement.setAttribute('value', attribute.attrExprVal);

            // if(attribute.valid_Cd != '0') {
            //     inputElement.style.setProperty('border-color', 'red');
            // }

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                inputElement.setAttribute("disabled", "true");
            }

            editorElement.appendChild(inputElement);

            let element: any = document.createElement('button');
            element.setAttribute('class', 'fa fa-external-link');
            document.body.appendChild(element);

            let oldAttrExprVal: string = attribute.attrExprVal;
            function onClick() {
                let editorInputObj: EditorInputObj = new EditorInputObj();
                editorInputObj.objectWrapper = objectWrapper;
                editorInputObj.subObject = attribute;
                editorInputObj.subObjectCopy = attribute.copy();
                editorInputObj.exprVal = attribute.attrExprVal;
                editorInputObj.valueField = 'attrExprVal';
                editorInputObj.valid_CdField = 'valid_Cd';
                editorInputObj.srt_OrderField = 'srt_Order';
                editorInputObj.name = attribute.attrNm;
                editorInputObj.datatypeName = attribute.attrDTypNm;
                editorInputObj.objTypCode = objectWrapper.obj_Cd;
                editorInputObj.typeName = 'Attribute';
                editorInputObj.valid_Cd = attribute.valid_Cd;

                component.openEditorPopup(editorInputObj);
            }
            element.addEventListener("click", onClick);

            function onBlur() {
                if (attribute.attrExprVal != inputElement.value) {
                    attribute.attrExprVal = inputElement.value;
                    attribute.valid_Cd = "0";

                    objectWrapper.doValidate();
                    component.refreshCountForAttributeGrid++;
                }


                // if (attribute.attrExprVal == oldAttrExprVal) return;

                // let additionalCarryForwardAttributes: any = component.objectWrapper.getAdditionalCarryForwardAttributes(attribute.srt_Order);
                // let carryforwardAttributes: Array<any> = additionalCarryForwardAttributes[0];

                // let editorInputObj: EditorInputObj = new EditorInputObj();
                // editorInputObj.objectWrapper = objectWrapper;
                // editorInputObj.subObject = attribute;
                // editorInputObj.subObjectCopy = attribute.copy();
                // editorInputObj.exprVal = attribute.attrExprVal;
                // editorInputObj.valueField = 'attrExprVal';
                // editorInputObj.valid_CdField = 'valid_Cd';
                // editorInputObj.srt_OrderField = 'srt_Order';
                // editorInputObj.name = attribute.attrNm;
                // editorInputObj.datatypeName = attribute.attrDTypNm;
                // editorInputObj.objTypCode = objectWrapper.obj_Cd;
                // editorInputObj.carryForwardAttributes = carryforwardAttributes;
                // editorInputObj.fromTransform = true;
                // editorInputObj.typeName = 'Attribute';

                // component.validationService.onBlurValidation(editorInputObj)
                //     .subscribe(() => {
                //         component.refreshCountForAttributeGrid++;
                //     })
            }

            inputElement.addEventListener("blur", onBlur);
            editorElement.appendChild(element);

            return editorElement;
        }

        return column;
    }

    getLnk_Attr_Id(objectWrapper: ObjectWrapper, title: string = ''): any {
        let column: any = {};
        column.title = title == '' ? "Src Column Name" : title;
        column.field = 'lnk_Attr_Id';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let attributeObj: any = objectWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return '';

            return attributeObj.name;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            for (let i: number = 0; i < objectWrapper.carryForwardAttributes.length; i++) {
                let carryForwardAttribute = objectWrapper.carryForwardAttributes[i];

                let optgroup = document.createElement("optgroup");
                optgroup.label = carryForwardAttribute.name;

                for (let j: number = 0; j < carryForwardAttribute.items.length; j++) {
                    let option = document.createElement("option");

                    option.value = carryForwardAttribute.items[j].attr_Id;
                    option.text = carryForwardAttribute.items[j].text;

                    optgroup.appendChild(option);
                }

                editor.appendChild(optgroup);
            }

            editor.value = attribute.lnk_Attr_Id;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                attribute.lnk_Attr_Id = editor.value;
                for (let i: number = 0; i < objectWrapper.carryForwardAttributes.length; i++) {
                    let carryForwardAttribute: any = objectWrapper.carryForwardAttributes[i];

                    for (let j: number = 0; j < carryForwardAttribute.items.length; j++) {
                        let attributeItem: Attribute = carryForwardAttribute.items[j];
                        if (attributeItem.obj_Id == attribute.lnk_Obj_Id &&
                            attributeItem.attr_Id == attribute.lnk_Attr_Id) {
                            attribute.valid_Cd = AttributesGridUtil.getInstance().verifyFamily(attribute, attributeItem, objectWrapper) ? "0" : "-1";
                            break;
                        }
                    }
                }
                objectWrapper.doValidate();
                success(attribute.lnk_Attr_Id);

                setTimeout(() => {
                    cell.getRow().reformat();
                });
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getPiiType(objectWrapper: ObjectWrapper): void {
        let column: any = {};
        column.title = "PII Type";
        column.field = 'piiType';
        column.width = 250;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let element: any = document.createElement("span");
            element.innerHTML = attribute.piiType;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let values: Array<any> = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.retMsgObjects);

            for (let i: number = 0; i < values.length; i++) {

                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.piiType;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (editor.value == attribute.piiType) {
                    success(editor.value);
                    return;
                }

                attribute.piiType = editor.value;
                attribute.masking_Strategy = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.persistVal[attribute.piiType])[0].value;
                attribute.strategy_Rule = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.persistVal[attribute.masking_Strategy])[0].value;
                attribute.repeat_Flag = 'Yes';
                objectWrapper.setChange_Ind();
                success(editor.value);
                cell.getRow().reformat();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getMaskingStratagy(objectWrapper: ObjectWrapper): void {
        let column: any = {};
        column.title = "Masking Strategy";
        column.field = 'masking_Strategy';
        column.width = 250;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let element: any = document.createElement("span");
            element.innerHTML = attribute.masking_Strategy;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let values: Array<any> = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.persistVal[attribute.piiType]);

            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.masking_Strategy;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                attribute.masking_Strategy = editor.value;
                attribute.strategy_Rule = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.persistVal[attribute.masking_Strategy])[0].value;
                attribute.repeat_Flag = 'Yes';
                objectWrapper.setChange_Ind();
                success(editor.value);
                cell.getRow().reformat();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getStratagyRule(objectWrapper: ObjectWrapper): void {
        let column: any = {};
        column.title = "Strategy Rule";
        column.field = 'strategy_Rule';
        column.width = 250;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let element: any = document.createElement("span");
            element.innerHTML = attribute.strategy_Rule;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let values: Array<any> = ObjectWrapperUtil.getInstance().getOptionsByValues(objectWrapper.maskingStratagy.persistVal[attribute.masking_Strategy]);

            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.strategy_Rule;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.strategy_Rule = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getRepeatFlag(objectWrapper: ObjectWrapper): void {
        let column: any = {};
        column.title = "Repeat Flag";
        column.field = 'repeat_Flag';
        column.width = 250;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let element: any = document.createElement("span");
            element.innerHTML = attribute.repeat_Flag;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";
            if (attribute.piiType == "") return;
            let values: Array<any> = ObjectWrapperUtil.getInstance().getYesNo();

            for (let i: number = 0; i < values.length; i++) {
                let option = document.createElement("option");
                option.value = values[i].value;
                option.text = values[i].value;

                editor.appendChild(option);
            }
            editor.value = attribute.repeat_Flag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.repeat_Flag = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getSrcColumn(objectWrapper: ObjectWrapper, title: string = ''): any {
        let column: any = {};
        column.title = "Src Column Name";
        column.field = 'lnk_Attr_Id';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let attributeObj: any = objectWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return '';

            return attributeObj.name;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        return column;
    }

    getOutPutLnk_Attr_Id(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Output Column Name";
        column.field = 'lnk_Attr_Id';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let attribute: Attribute = cell.getData();
            if (attribute.lnk_Obj_Id == -1 &&
                attribute.lnk_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = objectWrapper.outPutAttributesHMapIds[attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id];
            if (!attributeObj) return "";

            return attributeObj.name;
        }

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getData();

            let editor: any;
            editor = document.createElement("select");
            editor.id = "mySelect";
            if (objectWrapper.mode_Ind == 'R') return;
            if (objectWrapper.outPutAttributes.length > 0) {
                let obj_Nm: string = '';
                for (let i: number = 0; i < objectWrapper.outPutAttributes[0].items.length; i++) {
                    let option: any = document.createElement("option");

                    if (obj_Nm != objectWrapper.outPutAttributes[0].items[i].obj_Nm) {
                        obj_Nm = objectWrapper.outPutAttributes[0].items[i].obj_Nm;

                        option.value = objectWrapper.outPutAttributes[0].items[i].obj_Nm;
                        option.text = objectWrapper.outPutAttributes[0].items[i].obj_Nm;
                        editor.appendChild(option);
                    }

                    option.value = objectWrapper.outPutAttributes[0].items[i].obj_Id + '-' + objectWrapper.outPutAttributes[0].items[i].attr_Id;
                    option.text = objectWrapper.outPutAttributes[0].items[i].name;

                    editor.appendChild(option);
                }
            }

            editor.value = attribute.lnk_Obj_Id + "-" + attribute.lnk_Attr_Id;
            //cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (editor.value == "") {
                    success(editor.value);
                    return;
                }

                // if (editor.value == oldValue) {
                //     success(editor.value);
                //     return;
                // }

                let obj_Attr_Ids: Array<any> = editor.value.split('-');

                attribute.lnk_Obj_Id = parseInt(obj_Attr_Ids[0]);
                attribute.lnk_Attr_Id = parseInt(obj_Attr_Ids[1]);

                for (let i: number = 0; i < objectWrapper.outPutAttributes.length; i++) {
                    let carryForwardGroupAttribute: any = objectWrapper.outPutAttributes[i];

                    if (carryForwardGroupAttribute.obj_Id == attribute.lnk_Obj_Id &&
                        carryForwardGroupAttribute.attr_Id == attribute.lnk_Attr_Id) {

                        attribute.valid_Cd = AttributesGridUtil.getInstance().verifyFamily(attribute, carryForwardGroupAttribute, objectWrapper) ? "0" : "-1";
                        break;
                    }
                }
                objectWrapper.doValidate();
                success(attribute.lnk_Attr_Id);

                setTimeout(() => {
                    cell.getRow().reformat();
                });

            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }
        return column;
    }

    getLnk_Attr_Datatype(objectWrapper: ObjectWrapper, title: string = ''): any {
        let column: any = {};

        column.title = title == '' ? "Src Data Type" : title;
        column.field = "srcDTypNm";
        column.width = 150;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let attributeObj: any = objectWrapper.carryForwardAttributesHMapIds.get(attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id);
            if (!attributeObj) return '';

            return attributeObj.attrDTypNm;
        }
        return column;
    }

    getOutPutLnk_Attr_Datatype(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Output Data Type";
        column.field = 'srcDTypNm';
        column.width = 150;
        column.headerSort = false;
        column.formatter = function getValue(cell) {
            let attribute: Attribute = cell.getData();
            if (attribute.lnk_Obj_Id == -1 &&
                attribute.lnk_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = objectWrapper.outPutAttributesHMapIds[attribute.lnk_Obj_Id + '-' + attribute.lnk_Attr_Id];
            if (!attributeObj) return "";

            return attributeObj.attrDTypNm;
        }

        return column;
    }

    getUpiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "UPI";
        column.field = 'upiFlag';
        column.width = 50;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<any> = cell.getTable().rowManager.rows;
            let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < attributesList.length; i++) {
                let option = document.createElement("option");
                option.value = attributesList[i].value;
                option.text = attributesList[i].value;
                editor.appendChild(option);
            }

            editor.value = attribute.upiFlag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.upiFlag = editor.value;
                objectWrapper.doValidate();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getNupiFlag(objectWrapper: ObjectWrapper = null): any {
        let column: any = {};

        column.title = "NUPI";
        column.field = 'nupiFlag';
        column.width = 50;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<any> = cell.getTable().rowManager.rows;
            let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < attributesList.length; i++) {
                let option = document.createElement("option");
                option.value = attributesList[i].value;
                option.text = attributesList[i].value;
                editor.appendChild(option);
            }

            editor.value = attribute.nupiFlag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.nupiFlag = editor.value;
                objectWrapper.doValidate();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getUsiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "USI";
        column.width = 50;
        column.field = 'usiFlag';
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<any> = cell.getTable().rowManager.rows;
            let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < attributesList.length; i++) {
                let option = document.createElement("option");
                option.value = attributesList[i].value;
                option.text = attributesList[i].value;
                editor.appendChild(option);
            }

            editor.value = attribute.usiFlag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.usiFlag = editor.value;
                objectWrapper.doValidate();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getNusiFlag(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "NUSI";
        column.field = 'nusiFlag';
        column.width = 50;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<any> = cell.getTable().rowManager.rows;
            let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getAttributesLengthList(attributes);
            for (let i: number = 0; i < attributesList.length; i++) {
                let option = document.createElement("option");
                option.value = attributesList[i].value;
                option.text = attributesList[i].value;
                editor.appendChild(option);
            }

            editor.value = attribute.nusiFlag;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.nusiFlag = editor.value;
                objectWrapper.doValidate();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getClevel(objectWrapper: ObjectWrapper, isComplex: boolean): any {
        let column: any = {};

        column.title = "Level";
        column.width = "70";
        column.field = 'clevel';
        column.headerSort = false;
        column.visible = isComplex;

        return column;
    }

    getOccurs(objectWrapper: ObjectWrapper, title: string = '') {
        let column: any = {};

        column.title = title ? title : "Occurs";
        column.field = "occurs";
        column.width = 70;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.occurs == 1) return "";
            if (attribute.occurs == -1) return "unbounded";

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.occurs;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.occurs;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;


        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!attribute.occurs) {
                let element: any = document.createElement("span");
                return element;
            }

            if (attribute.isEditable == CommonEnums.flag.NO) {
                let element: any = document.createElement("span");
                element.classList.add("font-italic");
                element.innerHTML = attribute.occurs;
                return element;
            }

            let editor: any = document.createElement("input");
            editor.type = 'number';
            editor.id = "myInput";

            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (attribute.occurs != editor.value) {
                    attribute.occurs = editor.value;
                    cell.getRow().reformat();
                }

                success(editor.value);
            }

            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getSelectedRefKey(objectWrapper: ObjectWrapper) {
        let column: any = {};

        column.title = "Reference Key";
        column.field = "selectedRefKey";
        column.width = 150;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "selectedRefKey_" + attribute.attr_Id;
            editor.id = "selectedRefKey_" + attribute.attr_Id;
            editor.checked = attribute.selectedRefKey == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.selectedRefKey = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getRedefines(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Redefines";
        column.field = "redefines";
        column.width = 150;
        column.headerSort = false;
        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributes: Array<any> = cell.getTable().rowManager.rows;
            let attributesList: Array<any> = ObjectWrapperUtil.getInstance().getRedefinesList(objectWrapper, attributes, attribute);
            for (let i: number = 0; i < attributesList.length; i++) {
                let option = document.createElement("option");
                option.value = attributesList[i].value;
                option.text = attributesList[i].value;
                editor.appendChild(option);
            }

            editor.value = attribute.redefines;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.redefines = editor.value;
                objectWrapper.doValidate();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getAttrType_Cd(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Type";
        column.field = "attrType_Cd";
        column.width = 80;
        column.headerSort = false;

        return column;
    }

    getMinOccurs(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.field = "minOccurs";
        column.title = "Min Occurs";
        column.headerSort = false;
        column.width = 80;

        return column;
    }

    getDependingOn(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Depending On";
        column.field = "dependingOn";
        column.width = 200;
        column.headerSort = false;

        return column;
    }

    getFormat(objectWrapper: ObjectWrapper): any {
        let column: any = {};
        column.title = "Usage";
        column.field = 'colformat';
        column.width = 100;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.colformat
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.colformat;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor: any = document.createElement("select");
            editor.id = "mySelect";
            let getFormatValuesList = [{ "value": "0", label: 'Please Select' },
            { "value": "1", "label": 'BINARY' },
            { "value": "2", "label": 'COMP' },
            { "value": "3", "label": 'COMP-1' },
            { "value": "4", "label": 'COMP-2' },
            { "value": "5", "label": 'COMP-3' },
            { "value": "6", "label": 'PACKED' },
            { "value": "7", "label": 'USAGE COMP' },
            { "value": "8", "label": 'USAGE COMP-1' },
            { "value": "9", "label": 'USAGE COMP-2' },
            { "value": "10", "label": 'USAGE COMP-3' }];

            for (let i: number = 0; i < getFormatValuesList.length; i++) {

                let option = document.createElement("option");
                option.value = getFormatValuesList[i].label;
                option.text = getFormatValuesList[i].label;

                editor.appendChild(option);
            }
            editor.value = attribute.colformat;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                success(editor.value);
                attribute.colformat = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getSigned(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "S";
        column.field = "signed";
        column.width = 30;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "signed_" + attribute.attr_Id;
            editor.id = "signed_" + attribute.attr_Id;
            editor.checked = attribute.signed == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.signed = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }


    getTsigned(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "T";
        column.field = "tsigned";
        column.width = 30;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "tsigned_" + attribute.attr_Id;
            editor.id = "tsigned_" + attribute.attr_Id;
            editor.checked = attribute.tsigned == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.tsigned = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getIsigned(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "L";
        column.field = "isigned";
        column.width = 30;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            let editor = document.createElement('input');

            editor.type = "checkbox";
            editor.name = "isigned_" + attribute.attr_Id;
            editor.id = "isigned_" + attribute.attr_Id;
            editor.checked = attribute.isigned == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.isigned = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getRdeci(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "R";
        column.field = "rdeci";
        column.width = 30;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "rdeci_" + attribute.attr_Id;
            editor.id = "rdeci_" + attribute.attr_Id;
            editor.checked = attribute.rdeci == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.rdeci = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getExplodeFlag(objectWrapper: ObjectWrapper, isShowExplodeColumn: boolean = false): any {
        let column: any = {};

        column.title = "Explode";
        column.field = 'explodeFlag';
        column.width = 100;
        column.headerSort = false;
        column.visible = isShowExplodeColumn;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "explodeFlag_" + attribute.attr_Id;
            editor.id = "explodeFlag_" + attribute.attr_Id;
            editor.checked = attribute.explodeFlag == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.disabled = true;
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.explodeFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getFldFormatValue(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = 'Dist Value';
        column.field = "fldFormatValue";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.fldFormatValue;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.fldFormatValue;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.fldFormatValue;

            function successFunc() {
                attribute.fldFormatValue = editor.value;
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);

            onRendered(function () {
                editor.focus();
            });

            return editor;
        }

        return column;
    }

    getFldValue(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = 'Value';
        column.field = "fldValue";
        column.width = 100;
        column.headerSort = false;
        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.fldValue;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.fldValue;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.fldValue;

            function successFunc() {
                attribute.fldValue = editor.value;
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);

            onRendered(function () {
                editor.focus();
            });

            return editor;
        }

        return column;
    }

    getDescription(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Description";
        column.field = 'description';
        column.width = 150;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.description;
            }

            let element: any = document.createElement("span");
           // element.classList.add("font-italic");
            element.innerHTML = attribute.description;

            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement("input");
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.description;

            function successFunc() {
                attribute.description = editor.value;
                objectWrapper.setChange_Ind();

                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);

            onRendered(function () {
                editor.focus();
            });

            return editor;
        }
        return column;

    }
    // getDescription(objectWrapper: ObjectWrapper): any {
    //     let column: any = {};
    //     column.title = "Description";
    //     column.field = 'description';
    //     column.width = 150;
    //     column.headerSort = false;
        
 
    //     const shouldShowDescription: boolean = objectWrapper.showDescription || false;
     
    //     if (shouldShowDescription) {
    //         column.formatter = function (cell, formatterParams, onRendered) {
    //             let attribute: Attribute = cell.getRow()._row.data;
    //             return attribute.description;
    //         }
    //     } else {
            
    //         column.formatter = function () {
    //             return "";
    //         }
    //     }

    //     return column;
    // }
   
    // getDescription(objectWrapper: ObjectWrapper): any {
    //     let column: any = {};
     
    //     column.title = "Description";
    //     column.field = 'description';
    //     column.width = 150;
    //     column.headerSort = false;
     
    //     // Check if there are descriptions of selected attributes
    //     const hasSelectedAttributeDescriptions: boolean = objectWrapper.selectedAttributeDescriptions.length > 0;
     
    //     // Check if the description should be shown
    //     if (hasSelectedAttributeDescriptions) {
    //         column.formatter = function (cell, formatterParams, onRendered) {
    //             let attribute: Attribute = cell.getRow()._row.data;
    //             return objectWrapper.selectedAttributeDescriptions.includes(attribute.description) ? attribute.description : "";
    //         }
    //     } else {
    //         // Hide the description column
    //         column.formatter = function () {
    //             return "";
    //         }
    //     }
     
    //     return column;
    // }
        // Add editor logic if needed
        // if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.READ_ONLY &&
        //     objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.READ_ONLY) {
        //     column.editor = function (cell, onRendered, success, cancel, editorParams) {
        //         let attribute: Attribute = cell.getRow()._row.data;
        //         let editor = document.createElement("input");

        //         // Add your editor logic here
        //         // ...

        //         return editor;
        //     }
        // }

    // getDescription(objectWrapper: ObjectWrapper): any {
    //     let column: any = {};

    //     column.title = "Description";
    //     column.field = 'description';
    //     column.width = 150;
    //     column.headerSort = false;

    //     column.formatter = function (cell, formatterParams, onRendered) {
    //       let attribute: Attribute = cell.getRow()._row.data;
    //       let element: any = document.createElement("span");
    //       element.classList.add("font-italic");
    //       element.innerHTML = attribute.description;
    //       return element;
    //     }

    //     return column;
    //   }
    // getDescription(objectWrapper: ObjectWrapper): any {
    //     let column: any = {};
    //     column.title = "Description";
    //     column.field = 'description';
    //     column.width = 150;
    //     column.headerSort = false;
    //     column.formatter = function (cell, formatterParams, onRendered) {
    //       let attribute: Attribute = cell.getRow()._row.data;
    //       let element: any = document.createElement("span");
    //       element.classList.add("font-italic");
    //       // Get the updated description from the attribute
    //       element.innerHTML = attribute.description || 'No description'; // Use the updated description
    //       return element;
    //     }
    //     return column;
    //   }
    getDescription1(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Description";
        column.field = 'description';
        column.width = 450;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.isEditable == CommonEnums.flag.YES) {
                return attribute.description;
            }

            let element: any = document.createElement("span");
            element.classList.add("font-italic");
            element.innerHTML = attribute.description;
            return element;
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement("input");
            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE || objectWrapper.obj_Cd == CommonEnums.codes.TARGET) {
                editor.setAttribute("disabled", "true");
                return editor;
            }
            editor.type = 'text';
            editor.id = "myInput";
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.value = attribute.description;

            function successFunc() {
                attribute.description = editor.value;
                this.changesMade = true
                objectWrapper.setChange_Ind();
                Repository.getInstance().setChange_Ind();
                success(editor.value);
            }
            editor.addEventListener("blur", successFunc);
            Repository.getInstance().setChange_Ind();
            onRendered(function () {
                editor.focus();
                Repository.getInstance().setChange_Ind();
            });

            return editor;

        }
        return column;

    }
    getTimestampSpec(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "TimestampSpec";
        column.field = "timestampSpec";
        column.width = 125;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "timestampSpec_" + attribute.attr_Id;
            editor.id = "timestampSpec_" + attribute.attr_Id;
            editor.checked = attribute.timestampSpec == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.timestampSpec = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.setChange_Ind();
            }

            return editor;
        }

        return column;
    }

    getMetricsSpec(objectWrapper: ObjectWrapper) {
        let column: any = {};

        column.title = "MetricsSpec";
        column.field = "metricsSpec";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "metricsSpec_" + attribute.attr_Id;
            editor.id = "metricsSpec_" + attribute.attr_Id;
            editor.checked = attribute.metricsSpec == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.metricsSpec = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.doValidate();
            }

            return editor;
        }

        return column;
    }

    getMetricsType(objectWrapper: ObjectWrapper) {
        let column: any = {};

        column.field = "metricsType";
        column.title = "MetricsType";
        column.width = 100;
        column.headerSort = false;

        return column;
    }

    getSaved_Column(objectWrapper: ObjectWrapper) {
        let column: any = {};

        column.title = "Saved Column";
        column.field = "saved_Column";
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "saved_Column_" + attribute.attr_Id;
            editor.id = "saved_Column_" + attribute.attr_Id;
            editor.checked = attribute.saved_Column == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.saved_Column = event.target.checked ? 1 : 0;
                objectWrapper.doValidate();
            }

            return editor;
        }

        return column;
    }

    getReportPerspective(objectWrapper: ObjectWrapper) {
        let column: any = {};

        column.field = "report_Perspective";
        column.title = "Report Perspective";
        column.width = 100;
        column.headerSort = false;

        return column;
    }

    getAttrCategory(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Category";
        column.field = 'category';
        column.width = "140";
        column.headerSort = false;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let categoryTypes: Array<any> = [
                { label: "User", value: "User" },
                { label: "Ad Exchange", value: "Ad Exchange" },
                { label: "DoubleClick Campaign Manager", value: "DoubleClick Campaign Manager" },
                { label: "Channel Grouping", value: "Channel Grouping" },
                { label: "Page Tracking", value: "Page Tracking" },
                { label: "Time", value: "Time" },
                { label: "Event Tracking", value: "Event Tracking" },
                { label: "Geo Network", value: "Geo Network" },
                { label: "System", value: "System" },
                { label: "Site Speed", value: "Site Speed" },
                { label: "Traffic Sources", value: "Traffic Sources" },
                { label: "Platform or Device", value: "Platform or Device" },
                { label: "Adsense", value: "Adsense" },
                { label: "DoubleClick Search", value: "DoubleClick Search" },
                { label: "Exceptions", value: "Exceptions" },
                { label: "Adwords", value: "Adwords" },
                { label: "DoubleClick for Publishers", value: "DoubleClick for Publishers" },
                { label: "Custom Variables or Columns", value: "Custom Variables or Columns" },
                { label: "Custom Variables or Columns", value: "Custom Variables or Columns" },
                { label: "Audience", value: "Audience" },
                { label: "Internal Search", value: "Internal Search" },
                { label: "DoubleClick Bid Manager", value: "DoubleClick Bid Manager" },
                { label: "Social Interactions", value: "Social Interactions" },
                { label: "Ecommerce", value: "Ecommerce" },
                { label: "DoubleClick for Publishers Backfill", value: "DoubleClick for Publishers Backfill" },
                { label: "User Timings", value: "User Timings" },
                { label: "Content Experiments", value: "Content Experiments" },
                { label: "Goal Conversions", value: "Goal Conversions" },
                { label: "App Tracking", value: "App Tracking" },
                { label: "Content Grouping", value: "Content Grouping" },
                { label: "Lifetime Value and Cohorts", value: "Lifetime Value and Cohorts" },
                { label: "Session", value: "Session" },
            ]
            for (let i: number = 0; i < categoryTypes.length; i++) {
                let option = document.createElement("option");
                option.value = categoryTypes[i].label;
                option.text = categoryTypes[i].label;
                editor.appendChild(option);
            }

            editor.value = attribute.category;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            function successFunc() {
                success(editor.value);
                attribute.piiFlag = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getAttrType(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.field = "colformat";
        column.title = "Attribute Type";
        column.width = 130;
        column.headerSort = false;
        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            let attributeTypes: Array<any> = [
                { "value": "0", "label": "DIMENSION" },
                { "value": "1", "label": "METRIC" },
            ]
            for (let i: number = 0; i < attributeTypes.length; i++) {
                let option = document.createElement("option");
                option.value = attributeTypes[i].label;
                option.text = attributeTypes[i].label;
                editor.appendChild(option);
            }

            editor.value = attribute.colformat;
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            function successFunc() {
                success(editor.value);
                attribute.piiFlag = editor.value;
                objectWrapper.setChange_Ind();
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }

    getColFormat(objectWrapper: ObjectWrapper, isGoogleAnalytics: boolean = false): any { //
        let column: any = {};

        column.title = "Attribute Type";
        column.field = 'colformat';
        column.width = 100;
        column.headerSort = false;

        column.visible = isGoogleAnalytics;

        return column;
    }

    getAttrPiiIdentifierFlag(objectWrapper: ObjectWrapper, isShowPIIColumn: boolean): any {
        let column: any = {};

        column.title = "Data Sensitivity";
        column.field = 'piiFlag';
        column.width = 120;
        column.visible = isShowPIIColumn;
        column.headerSort = false;

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        if (objectWrapper.obj_Cd == CommonEnums.codes.DATAOBJECT) {
            column.editor = function (cell, onRendered, success, cancel, editorParams) {
                let attribute: Attribute = cell.getRow()._row.data;

                let editor: any = document.createElement("select");
                editor.id = "mySelect";

                let piiFlagTypes: Array<any> = [
                    { "value": "0", "label": "NA", "desc": "None" },
                    { "value": "1", "label": "SPIRSH", "desc": "Sensitive Personally Identifiable Information with a Real Risk of Significant Harm" },
                    { "value": "2", "label": "SPII", "desc": "Sensitive Personally Identifiable Information" },
                    { "value": "3", "label": "PIIPD", "desc": "Personally Identifiable Information in the public domain" },
                    { "value": "4", "label": "PII", "desc": "Personally Identifiable Information" },
                    { "value": "5", "label": "PD", "desc": "Personal Data" }
                ]

                for (let i: number = 0; i < piiFlagTypes.length; i++) {
                    let option = document.createElement("option");
                    option.value = piiFlagTypes[i].label;
                    option.text = piiFlagTypes[i].label;
                    editor.appendChild(option);
                }

                editor.value = attribute.piiFlag;
                editor.style.width = "100%";
                editor.style.boxSizing = "border-box";

                onRendered(function () {
                    editor.focus();
                });

                function successFunc() {
                    success(editor.value);
                    attribute.piiFlag = editor.value;
                    objectWrapper.setChange_Ind();
                }
                editor.addEventListener("change", successFunc);
                editor.addEventListener("blur", successFunc);
                return editor;
            }
        }
        return column;
    }

    getTranspose(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Transpose";
        column.field = 'transpose';
        column.width = 80;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;
            if (!objectWrapper.databaseWrapper.showAttributeTranspose(attribute, objectWrapper)) return;
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "transpose_" + attribute.attr_Id;
            editor.id = "transpose_" + attribute.attr_Id;
            editor.checked = attribute.transpose == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.transpose = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.doValidate();
            }

            return editor;
        }

        return column;
    }

    getEncode(objectWrapper: ObjectWrapper, isEncode: boolean = false): any {
        let column: any = {};

        column.title = "Encode";
        column.field = 'encode';
        column.width = 100;
        column.headerSort = false;
        column.visible = isEncode;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "encode_" + attribute.attr_Id;
            editor.id = "encode_" + attribute.attr_Id;
            editor.checked = attribute.encode == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute('class', 'isDisabled');
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.encode = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                editor.value = attribute.encode;
                objectWrapper.doValidate();
            }

            return editor;
        }

        return column;
    }

    getReferKey(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Reference Key";
        column.field = "selectedRefKey";
        column.width = 175;
        column.headerSort = false;
        column.resizable = true;
        column.formatter = function (cell) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.xmlRefKeys.length == 0 ||
                attribute.clevel == 1 ||
                attribute.occurs != -1) return;

            let customDropdownDiv: any = document.createElement("div");
            customDropdownDiv.classList.add("dropdown");

            let buttonElement = document.createElement('BUTTON');
            buttonElement.setAttribute("class", "btn dropdown-toggle ellipsis w-100 h-100 p-0");
            buttonElement.setAttribute("id", "dropdownMenuButton");
            buttonElement.setAttribute("data-toggle", "dropdown");
            buttonElement.setAttribute("aria-haspopup", "true");
            buttonElement.setAttribute("aria-expanded", "false");
            buttonElement.addEventListener('click', addClass);

            let spanTag = document.createElement('span');
            spanTag.setAttribute('class', 'ellipsis w-100 text-left');
            spanTag.appendChild(document.createTextNode(attribute.selectedRefKey));
            buttonElement.title = attribute.selectedRefKey

            buttonElement.appendChild(spanTag);

            customDropdownDiv.appendChild(buttonElement);

            let ul: any = document.createElement('ul');
            ul.classList.add("dropdown-menu");
            ul.classList.add("px-2");
            ul.setAttribute('role', 'menu');
            ul.setAttribute('aria-labelledby', 'dropdownMenuButton');

            for (let i: number = 0; i < attribute.xmlRefKeys.length; i++) {
                let li: any = document.createElement('li');
                let checkBox: any = document.createElement('input');

                checkBox.type = "checkbox";
                checkBox.checked = attribute.xmlRefKeys[i].selected == 'Y' ? true : false;
                checkBox.addEventListener('click', changeRefKey.bind(null, attribute.xmlRefKeys[i]));

                let label = document.createElement('label');
                label.setAttribute('class', 'ml-2');
                label.htmlFor = "id";
                label.appendChild(document.createTextNode(attribute.xmlRefKeys[i].attrNm));

                li.appendChild(checkBox);
                li.appendChild(label);

                ul.appendChild(li);
            }
            customDropdownDiv.appendChild(ul);

            function addClass() {
                if (!buttonElement.classList.contains("bc-3l")) {
                    buttonElement.classList.add("bc-3l")
                }
            }

            function removeClass() {
                if (buttonElement.classList.contains("bc-3l")) {
                    buttonElement.classList.remove("bc-3l");
                }
            }

            function changeRefKey(slectedRefkey, event) {
                slectedRefkey.selected = event.target.checked ? 'Y' : 'N';

                let selectedRefKeysTmp = attribute.selectedXmlRefKeys.split(',')
                let selectedRefKeys: Array<any> = new Array<any>();
                attribute.selectedXmlRefKeys = '';

                if (selectedRefKeysTmp.length == 0 || (selectedRefKeysTmp.length == 1 &&
                    selectedRefKeysTmp[0] == '')) {
                    selectedRefKeysTmp.splice(0, selectedRefKeysTmp.length);
                    attribute.selectedXmlRefKeys += slectedRefkey.attr_Id;
                    attribute.selectedRefKey = slectedRefkey.attrNm;
                    buttonElement.textContent = attribute.selectedRefKey;
                    buttonElement.title = attribute.selectedRefKey
                    // cell.getRow().update({ "selectedRefKey": attribute.selectedRefKey });
                    // cell.getRow().reformat();
                    removeClass();
                    objectWrapper.setChange_Ind();
                    return;
                } else {

                    for (let i: number = 0; i < selectedRefKeysTmp.length; i++) {
                        selectedRefKeys.push(parseInt(selectedRefKeysTmp[i]));
                    }

                    let index = selectedRefKeys.indexOf(slectedRefkey.attr_Id);
                    if (index != -1) {
                        selectedRefKeys.splice(index, 1);
                    } else {
                        selectedRefKeys.push(parseInt(slectedRefkey.attr_Id));
                    }
                }


                selectedRefKeys.sort(function (a, b) { return a - b });

                for (let i: number = 0; i < selectedRefKeys.length; i++) {
                    if (selectedRefKeys.length - 1 == i) {
                        attribute.selectedXmlRefKeys += selectedRefKeys[i];
                    } else
                        attribute.selectedXmlRefKeys += selectedRefKeys[i] + ',';
                }

                let selectedParent = '';
                if (selectedRefKeys.length > 0) {
                    for (let i: number = 0; i < objectWrapper.object.attributes.length; i++) {
                        if (objectWrapper.sub_Ids.get(parseInt(selectedRefKeys[0])).parent_Attr_Id == objectWrapper.object.attributes[i].attr_Id) {
                            selectedParent = objectWrapper.object.attributes[i].attrNm;
                        }
                    }
                }

                attribute.selectedRefKey = selectedRefKeys.length > 0 ? selectedParent + '.' + objectWrapper.sub_Ids.get(parseInt(selectedRefKeys[0])).attrNm : '';
                buttonElement.textContent = attribute.selectedRefKey;
                buttonElement.title = attribute.selectedRefKey;
                // cell.getRow().update({ "selectedRefKey": attribute.selectedRefKey });

                //  cell.getRow().reformat();
                removeClass();
                objectWrapper.setChange_Ind();
            }

            return customDropdownDiv;
        }

        return column;
    }

    getTransposeKeyColumn(objectWrapper: ObjectWrapper, transposetype: string) {
        let column: any = {};

        column.field = "transposeKey";
        column.title = "Key";
        column.visible = transposetype == CommonEnums.transposetype.COLLAPSE;
        column.width = 80;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "transposeKey_" + attribute.attr_Id;
            editor.id = "transposeKey_" + attribute.attr_Id;
            editor.checked = attribute.transposeKey == CommonEnums.flag.YES;

            if (attribute.transposeData == CommonEnums.flag.YES ||
                objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.transposeKey = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                objectWrapper.doValidate();
            }

            return editor;
        }

        return column;
    }

    getTransposeDataColumn(objectWrapper: ObjectWrapper, attributes: Array<Attribute>, transposetype: string) {
        let column: any = {};

        column.field = "transposeData";
        column.title = transposetype == CommonEnums.transposetype.COLUMNSTOROWS ? 'Transpose' : 'Collapse'
        column.width = 80;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.transpose == CommonEnums.flag.YES) {
                return "";
            }

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "transposeData_" + attribute.attr_Id;
            editor.id = "transposeData_" + attribute.attr_Id;
            editor.checked = attribute.transposeData == CommonEnums.flag.YES;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.transposeData = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                cell.getRow().reformat();

                if (attribute.transposeData == CommonEnums.flag.NO) {
                    objectWrapper.doValidate();
                    return;
                }
                let rowComponents: Array<any> = cell.getTable().getRows();
                if (transposetype == CommonEnums.transposetype.COLLAPSE) {
                    for (let i: number = 0; i < rowComponents.length; i++) {
                        let attributeTmp: Attribute = rowComponents[i]._row.data;
                        if (attributeTmp.attr_Id == attribute.attr_Id) continue;

                        if (attributeTmp.transposeData == CommonEnums.flag.YES) {
                            attributeTmp.transposeData = CommonEnums.flag.NO;
                            rowComponents[i].reformat();
                        }
                    }
                }

                objectWrapper.doValidate();
            }
            return editor;
        }
        return column;
    }

    getUnique(objectWrapper: ObjectWrapper, component: any): any {
        let column: any = {};

        column.title = "Unique";
        column.width = 80;
        column.field = 'distKeyFlag';
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.hiddenFlg == 'Y') {
                return "<span></span>";
            }

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "distkeyflag_" + attribute.attr_Id;
            editor.id = "distkeyflag_" + attribute.attr_Id;
            editor.checked = attribute.distKeyFlag == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.distKeyFlag = event.target.checked ? 1 : 0;
                objectWrapper.setChange_Ind();
                component.updateShowUniqueDropdown();
            }

            return editor;
        }

        return column;
    }

    getSortBy(objectWrapper: ObjectWrapper, component: any): any {
        let column: any = {};

        column.title = "Sort";
        column.width = 50;
        column.field = 'sortBy';
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.hiddenFlg == 'Y') {
                return "<span></span>";
            }

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "sortBy_" + attribute.attr_Id;
            editor.id = "sortBy_" + attribute.attr_Id;
            editor.checked = attribute.sortBy == 1;

            if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                attribute.sortBy = event.target.checked ? 1 : 0;
                if (attribute.sortBy == 0) {
                    attribute.sortType = "A";
                }
                objectWrapper.setChange_Ind();
                component.updateRefreshCountForAttributes();
            }

            return editor;
        }

        return column;
    }

    getAscDsc(objectWrapper: ObjectWrapper): any {
        let column: any = {};

        column.title = "Asc/Dsc";
        column.field = 'sortType';
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.hiddenFlg == 'Y' || attribute.sortBy == 0) {
                return "<span></span>";
            }

            let value = attribute.sortType == 'A' ? 'Asc' : 'Dsc'
            if (attribute.sortBy == 1) {
                return "<span>" + value + "</span>"
            } else {
                return '';
            }
        }

        if (objectWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;
        if (objectWrapper.databaseWrapper.attributesMode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editorParams = {
            sortValuesList: "asc",
            values: objectWrapper.labelValueObjs
        };

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let attribute: Attribute = cell.getRow()._row.data;

            if (attribute.hiddenFlg == 'Y' || attribute.sortBy == 0) {
                return "<span></span>";
            }
            function successFuncOnDisabled() {
                cancel();
            }

            let editor: any = document.createElement("select");
            editor.id = "mySelect";

            if (attribute.isEditable == CommonEnums.flag.NO) {
                editor.disabled = true;
                editor.addEventListener("click", successFuncOnDisabled);
            }

            for (let i: number = 0; i < editorParams.values.length; i++) {
                let option = document.createElement("option");

                option.value = editorParams.values[i].value;
                option.text = editorParams.values[i].label;

                editor.appendChild(option);
            }

            editor.value = attribute.sortType;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                if (attribute.sortType == editor.value) {
                    success(editor.value);
                    return;
                }

                attribute.sortType = editor.value;

                AttributesUtil.getInstance().setAttributeReadOnlyProperties(attribute, objectWrapper);
                objectWrapper.doValidate();

                success(editor.value);
            }
            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }
        return column;
    }
}